import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import HmAjax from '../../util/HmAjax';
import HmEventRegistry from '../../model/HmEventRegistry';

const proClass = '';

// ES6 class-style
class za_Footer extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isLoaded: false,
			items: [],
			ProductList: [],
			pro_detail: [],
			products : [],
			self: [],
			plp:[],
			products_details: {},
			products_category_order:[]
		};
		this.grades = this.props.grades;
		this.productClass = this.props.products_class;
		this.productDetails = this.props.products_details;
		this.products_category = this.props.products_category;
		this.productClasses = this.props.classes;
		this.state.products = (Object.keys(this.products_category));
		this.restricted = false;

		this.userObj = null;
		this.restrictedCategories = window.footerRestrictedProdCategories || [];
	}

	componentDidMount() {
		const { products,self,plp } = this.state;
		this.grades = this.props.grades;
		this.productClass = this.props.products_class;
		this.productDetails = this.props.products_details;
		this.products_category = this.props.products_category;
		this.productClasses = this.props.classes;
		this.state.products = (Object.keys(this.products_category));
	  	//HmEventRegistry.fireEvent("INITIATE_GA");
	}

	componentDidUpdate(){
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

  	render() {
  		const { products,self,plp } = this.state;
  		this.grades = this.props.grades;
  		this.grades_order = this.props.grades_order;
  		this.productClass = this.props.products_class;
  		this.productDetails = this.props.products_details;
  		this.products_category = this.props.products_category;
  		this.productClasses = this.props.classes;
  		this.state.products = (Object.keys(this.products_category));
  		this.state.products_category_order = this.props.products_category_order;
  		const tifOptions = [];

  		return(
  			<footer>
  			<div className="container">
					<div className="row follow-us">
					<div className="col-lg-4 col-md-5 no-padding">
					<div className="follow">
					<p>Follow us on</p>
					<ul>
					<li><a data-ga="Footer - Follow Us - Facebook"  href="https://www.facebook.com/heymath" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
					<li><a data-ga="Footer - Follow Us - Twitter" href="http://twitter.com/heymath" target="_blank"><i className="fab fa-twitter"></i></a></li>
					<li><a data-ga="Footer - Follow Us - Linkedin" href="http://linkedin.com/company/heymath" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
					<li><a data-ga="Footer - Follow Us - Youtube" href="http://bit.ly/HeyMathYouTube" target="_blank"><i className="fab fa-youtube"></i></a></li>
					</ul>
					</div>
					</div>
					<div className="col-lg-4 col-md norightpadding">
					
					
					</div>
					<div className="col-lg-4 col-md nopadding">
					<div className="text-link text-center">
					<span data-ga="Footer - Contact Us" className="r-btn contactbtn" onClick={this.props.showContactus}>Contact us</span>
					</div>
					</div>
					</div>
					<div className="row">
					<div className="col-md-4 text-link ">
					<p className="text-left">All rights reserved &copy; {this.rb("footer.copyright.year")} <strong>HeyMath!</strong> </p>
					</div>
					<div className="col-md-4 text-link">
					<a data-ga="Footer - Terms" href={this.getTermsUrl("ZA")} target="_blank"> Terms of Use</a>
					<span>|</span> <a data-ga="Footer - Privacy Policy" href={this.getUrlFor("LUMOS_PRIVACY")} target="_blank"> Privacy Policy</a>
					</div>
					<div className="col-md-4 text-link"> 
				</div>
				</div>
				</div>
				</footer>
				);
  	}
  }

  export default za_Footer;



// WEBPACK FOOTER //
// ./src/views/za/za_Footer.js